<div class="col-span-2">
  <label for="messageInput" class="field-label">
    {{ note }}
  </label>
  <textarea
    #messageInput
    id="messageInput"
    class="input-field !resize-none !w-full min-h-[120px]"
    [placeholder]="'Add ' + note + ' (Ex: Max 500 characters)'"
    rows="4"
    maxlength="500"
    (keyup)="onInputChange(messageInput.value)"
  ></textarea>
</div>

<!-- Rest of your template remains the same -->

<div class="col-span-2">
  <label class="field-label">Attachment</label>
  <div
    class="flex flex-col gap-3 justify-center items-center border border-[#E3E6EE] py-4 cursor-pointer rounded"
    (click)="triggerFileUpload()"
  >
    <img
      src="../../../../../../assets/images/icons/tickets/semicolon-gray.svg"
      alt=""
      class="h-10 w-10"
    />
    <p class="font-normal text-sm leading-5 text-[#6F737B] text-center">
      <span class="font-medium text-[#15191E]">Click to upload</span> or drag
      and drop <br />
      PNG, JPG or HEIC
    </p>
  </div>

  <!-- Hidden file input -->
<input
  type="file"
  #fileUpload
  id="fileupload"
  hidden
  multiple
  (change)="handleFileInput($event)"
  accept=".jpg,.jpeg,.svg,.png,.gif,.heic"
/>


 <!-- Uploaded files display -->
<div class="mt-3 flex flex-wrap gap-2">
<!--  <div-->
<!--    *ngFor="let file of lstUploadedFiles; let i = index"-->
<!--    class="flex items-center gap-2 px-2 py-0.5 bg-gray-200 text-sm rounded-full" matTooltip ="{{file.AttachmentName}}"-->
<!--  >-->
<!--    {{truncateFileName(file.AttachmentName)}}-->
<!--    <span-->
<!--      class="cursor-pointer text-red-600 text-lg font-bold ml-1"-->
<!--      (click)="remove(file.AttachmentName)"-->
<!--      title="Remove"-->
<!--    >-->
<!--      &times;-->
<!--    </span>-->
<!--  </div>-->



  <div *ngFor="let file of lstUploadedFiles; let i = index" matTooltip ="{{file.AttachmentName}}">
    <p
      class="px-2 py-1 bg-[#EBEBEE] flex items-center justify-center gap-1.5 rounded-2xl cursor-pointer max-w-40">
              <span class="text-[#6f6f6f] font-medium text-xs leading-4 truncate whitespace-nowrap overflow-hidden">
                {{truncateFileName(file.AttachmentName)}}
              </span>
      <img src="../../../assets/images/icons/global/popup-cross.svg" alt="" class="size-2" (click)="remove(file.AttachmentName)">
    </p>
  </div>

</div>
</div>
